// services/api/facturasApi.ts
import axios from 'axios';
import { ConfiguracionFactura, ConfiguracionResponse } from '../../components/module/facturas/types/facturas.types';

axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:4020';

export const facturasApi = {
  obtenerConfiguracion: async (): Promise<ConfiguracionResponse> => {
    try {
      const response = await axios.post('/configuracion-facturas/obtener');
      return response.data;
    } catch (error) {
      console.error('Error al obtener configuración:', error);
      throw error;
    }
  },

  actualizarConfiguracion: async (config: Omit<ConfiguracionFactura, 'Id'>): Promise<void> => {
    try {
      const { NumeroInicio, NumeroFin, NumeroActual, Prefijo } = config;
      await axios.post('/configuracion-facturas/actualizar', {
        NumeroInicio,
        NumeroFin,
        NumeroActual,
        Prefijo: Prefijo || ''
      });
    } catch (error) {
      console.error('Error al actualizar configuración:', error);
      throw error;
    }
  }
};